import jQuery from 'jquery';
export const Lazyload = {
  created() {
    jQuery('img').each(function() {
      var el = jQuery(this);
      var src = jQuery(this).attr('src');
      el.addClass('lazyload');
      el.attr('data-src', src);
    });
    document.addEventListener('lazybeforeunveil', function(e){
      const bgLoad = function(url, cb) {
        const regBgUrlEscape = /\(|\)|\s|'/;
        let img = document.createElement('img');
        // fix toDataURL SecurityError: The operation is insecure
        img.crossOrigin = 'anonymous';
        img.onload = function() {
          cb({
            status: 1,
            url: regBgUrlEscape.test(url) ? JSON.stringify(url) : url,
          });
          img.onload = null;
          img.onerror = null;
          img = null;
        };
        img.onerror = function() {
          cb({
            status: 0,
          });
        };
        img.src = url;
        if (img && img.complete && img.onload) {
          img.onload();
        }
      };

      const bg = e.target.getAttribute('data-bg');
      const bg_fallback = e.target.getAttribute('data-bg-fallback');
      if (bg) {
        const load = function(data) {
          if (data.status) {
            e.target.style.backgroundImage = 'url(' + data.url + ')';
          } else if (bg_fallback) {
            e.target.style.backgroundImage = 'url(' + bg_fallback + ')';
          }
        };
        bgLoad(bg, load);
      }
    });
  },
};
